//import {
//  HARD_MODE_DESCRIPTION,
//  HIGH_CONTRAST_MODE_DESCRIPTION,
//} from '../../constants/strings'
import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
  isDarkMode: boolean
  handleDarkMode: Function
  isHighContrastMode: boolean
  handleHighContrastMode: Function
}

export const NewsModal = ({
  isOpen,
  handleClose,
  isDarkMode,
  handleDarkMode,
  isHighContrastMode,
  handleHighContrastMode,
}: Props) => {
  // Append a timestamp to prevent caching
  const iframeSrc = `/daily-news.html?timestamp=${new Date().getTime()}`;

  return (
    <BaseModal title="Monthly Hints & Factoids" isOpen={isOpen} handleClose={handleClose}>
      <div className="mt-2 flex flex-col divide-y" style={{ height: '70vh' }}>
        <iframe 
          src={iframeSrc}
          title='MonthlyHints'
          style={{ 
            width: '100%', 
            height: '100%', 
            border: 'none', 
            overflow: 'hidden' 
          }} 
        />
      </div>
    </BaseModal>
  )
}
